/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('canvas', {
    ref: "bubble",
    style: _vm.style,
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };